<ng-container [formGroup]="formGroup">
  <app-city-select [formControl]="city"
                   [classList]="cityClasses"></app-city-select>

  <app-postbox-select [formControl]="warehouse"
                      [autofocus]="autofocus"
                      [cityRef]="cityRef"
                      [forSender]="forSender"
                      [classList]="warehouseClasses"></app-postbox-select>
</ng-container>
